import React from "react";
import { useCommentData } from "./CommentDataContext";
import "./QueryCountDetailComponent.css";

const QueryCountDetailComponent = () => {
  const {
    commentDetails,
    activeTab,
    selectedQuery,
    setSelectedQuery,
    setrectangleMode,
    setseeAllDots,
    setisDotMode,
    searchedCommentQueries,
    searchActive, 
  } = useCommentData();

  const currentTabData = commentDetails?.[activeTab] || [];
  const isSearching = !!searchActive;
  const displayData = isSearching ? (searchedCommentQueries || []) : currentTabData;

  const unit = 1e-6;
  const precesion = 1e-10;
  const dbu = unit / precesion;

  return (
    <div className="query-count-container">
      {isSearching && displayData.length === 0 ? (
        <div className="query-empty">No results.</div>
      ) : displayData.length > 0 ? (
        <>
          <div className="query-button-list">
              {displayData.map((item) => {
              const resolvedClass = item.is_resolved ? "resolved" : "";
              const selectedResolved =
                selectedQuery?.id === item?.id && item.is_resolved
                  ? "selected-resolved"
                  : "";

                const coordTitle = `(X: ${item.points.x / dbu}, Y: ${(item.points.y * -1) / dbu})`;

              return (
                <button
                  key={item.id}
                  title={coordTitle}
                  onClick={() => {
                    setSelectedQuery(item);
                    window.canvasEngine.FeatureRenderer.setSelectedQuery(item);
                    setseeAllDots(false);
                    setrectangleMode(false);
                    setisDotMode(false);
                    window.canvasEngine.FeatureRenderer.isDotMode = false;
                  }}
                  className={`query-number-button ${selectedQuery?.id === item.id ? "selected" : ""
                    } ${resolvedClass} ${selectedResolved} ${isSearching ? "search-match" : ""}`}
                >
                  {item.number}
                </button>
              );
              })}
            </div>
        </>
      ) : (
            <div className="query-empty">No entry to show.</div>
      )}
    </div>
  );
};

export default QueryCountDetailComponent;